// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popover":"_2rE_N","on-background":"_3KFiL"};